import { OrganizationDto } from "@intelligems/ig-types";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { useIsAdmin } from "@src/api/user-auths/is-admin";

export const canViewSitewideAnalytics = (
  org: OrganizationDto,
  isAdmin?: boolean
): boolean => {
  if (isAdmin) {
    return true;
  }

  const viewSitewideConfig = org.configurations?.find(
    (c) => c.key === "view_sitewide_analytics"
  );
  return viewSitewideConfig?.value ?? false;
};

export const canViewSitewideAnalyticsBetaPage = (
  org: OrganizationDto,
  isAdmin?: boolean
): boolean => {
  if (isAdmin) {
    return true;
  }

  const viewSitewideConfig = org.configurations?.find(
    (c) => c.key === "view_sitewide_analytics_beta_page"
  );
  return viewSitewideConfig?.value ?? false;
};

const canViewTestAnalytics = (
  org: OrganizationDto,
  isAdmin?: boolean
): boolean => {
  if (isAdmin) {
    return true;
  }

  const viewAnalyticsConfig = org.configurations?.find(
    (c) => c.key === "view_analytics"
  );
  return viewAnalyticsConfig?.value ?? false;
};

export const useCanViewSitewideAnalytics = () => {
  const isAdmin = useIsAdmin();
  const org = useGetOrg();
  return canViewSitewideAnalytics(org.data.org, isAdmin);
};

export const useCanViewSitewideAnalyticsBetaPage = () => {
  const isAdmin = useIsAdmin();
  const org = useGetOrg();
  return canViewSitewideAnalyticsBetaPage(org.data.org, isAdmin);
};

export const useCanViewTestAnalytics = () => {
  const isAdmin = useIsAdmin();
  const org = useGetOrg();
  return canViewTestAnalytics(org.data.org, isAdmin);
};
